import { ConsultationRequestError } from '@errors/consultation-request-error';

export class ConsultationRequestExpiredSessionError extends ConsultationRequestError {
  public constructor() {
    super(
      'It appears your session has expired. Please refer to the email we previously sent and revisit the questionnaire link to restart your session.',
    );
  }
}
